import React from 'react';
import UserRolesTable from './UserRolesTable';

export default function UserRolesPage() {
  return (
    <div className="eduss-page-wrapper">
      <UserRolesTable />
    </div>
  );
}